export default "__VITE_ASSET__DekVzL$$__"